<div class="header-cart" (click)="toCart()">

  <div class="header-cart__icon">
    <tui-icon icon="shopping-cart"/>
  </div>

  <div class="header-cart__info" (click)="toCart()">
    @if (amount$ | async; as amount) {
      <p>
        {{ createLabel(amount, 'товар|товара|товаров') }}
      </p>
    } @else {
      <small i18n="@@Empty">Пусто</small>
    }
    @if (cost$ | async; as cost) {
      <small>
        {{ cost | formatPriceNumber }} <span>₽</span>
      </small>
    }
  </div>
</div>

